module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0113.jpg?v=b1858824";